import type {
  Data, Variables, Cache, UpdatesConfig,
} from '@urql/exchange-graphcache';

import invalidateQuery from './util/invalidateQuery';

const noteExchange: UpdatesConfig['Mutation'] = {
  noteCreate: (_: Data, __: Variables, cache: Cache) => invalidateQuery(
    ['noteCreate', 'notes'],
    cache,
  ),
  noteDelete: (_: Data, __: Variables, cache: Cache) => invalidateQuery(
    ['noteCreate', 'notes'],
    cache,
  ),
};

export default noteExchange;
